import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";
import React from "react";

export const Container = styled.div`
    position: absolute;
    top: 10px;
    right: 30px;
    font-size: 36px;
    cursor: pointer;
    color: ${subduedTextColour};
    z-index: 100;
`;


export const CloseModalButton = ({closeModal}) => {
  return <Container className="t-exit-modal-button"
                    onClick={closeModal}>
      <span>&times;</span>
  </Container>;
};